import { useEffect } from 'react';
import { node } from 'prop-types';

import nG1CommService from '../ng1-comm/nG1Comm.service';

export default function Ng1CommunicationProvider(props) {
    const { children } = props;

    useEffect(() => {
        nG1CommService(console).connect();
    }, []);

    return children;
}

Ng1CommunicationProvider.propTypes = {
    children: node,
};

Ng1CommunicationProvider.defaultProps = {
    children: null,
};
